type GoogleDriveProps = {
  className?: string;
};

const GoogleDrive = ({ className }: GoogleDriveProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.1027 8.80241L8.98813 3.30596C9.09154 3.20068 9.2105 3.13162 9.32947 3.08521C8.41111 3.38748 7.98968 4.41884 7.98968 4.41884L2.29991 14.4573C2.21985 14.7721 2.19762 15.0562 2.20762 15.3065H8.41777L12.1027 8.80241Z"
      fill="#34A853"
    />
    <path
      d="M12.1027 8.80241L15.7876 15.3065H21.9978C22.0077 15.0562 21.9855 14.7721 21.9054 14.4573L16.2157 4.41884C16.2157 4.41884 15.7932 3.38748 14.8758 3.08521C14.9937 3.13162 15.1138 3.20068 15.2172 3.30596L12.1027 8.80241Z"
      fill="#FBBC05"
    />
    <path
      d="M12.1027 8.80309L15.2172 3.30668C15.1138 3.20139 14.9937 3.13233 14.8759 3.08591C14.7402 3.04176 14.5945 3.01232 14.4366 3.00439H14.272H9.93334H9.76875C9.61198 3.01119 9.4652 3.04063 9.3295 3.08591C9.2117 3.13233 9.09156 3.20139 8.98816 3.30668L12.1027 8.80309Z"
      fill="#188038"
    />
    <path
      d="M8.41865 15.3066L5.33974 20.7409C5.33974 20.7409 5.23744 20.691 5.09845 20.588C5.53544 20.9243 5.96019 20.9956 5.96019 20.9956H18.0524C18.7195 20.9956 18.8586 20.7409 18.8586 20.7409C18.8607 20.7397 18.8619 20.7385 18.8641 20.7375L15.7874 15.3066H8.41865Z"
      fill="#4285F4"
    />
    <path
      d="M8.41906 15.3066H2.20892C2.24006 16.0448 2.5603 16.4762 2.5603 16.4762L2.7938 16.8814C2.81048 16.9053 2.82049 16.9188 2.82049 16.9188L3.32864 17.8109L4.46947 19.7967C4.50283 19.877 4.54175 19.9506 4.58289 20.0208C4.59845 20.0446 4.61291 20.0706 4.62959 20.0933C4.63404 20.1 4.63848 20.1069 4.64294 20.1136C4.78415 20.3129 4.94204 20.4669 5.09993 20.588C5.23892 20.6922 5.34123 20.7409 5.34123 20.7409L8.41906 15.3066Z"
      fill="#1967D2"
    />
    <path
      d="M15.7877 15.3066H21.9977C21.9666 16.0448 21.6464 16.4762 21.6464 16.4762L21.4129 16.8814C21.3962 16.9053 21.3862 16.9188 21.3862 16.9188L20.878 17.8109L19.7372 19.7967C19.7038 19.877 19.6649 19.9506 19.6238 20.0208C19.6083 20.0446 19.5938 20.0706 19.5771 20.0933C19.5726 20.1 19.5682 20.1069 19.5637 20.1136C19.4225 20.3129 19.2647 20.4669 19.1067 20.588C18.9678 20.6922 18.8655 20.7409 18.8655 20.7409L15.7877 15.3066Z"
      fill="#EA4335"
    />
  </svg>
);

export default GoogleDrive;
